// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{font-size:100.01%;}

.holder{
	overflow:hidden;
	margin:0 0 31px;
}
.items-holder{overflow:hidden;}
#content .holder p{margin:0 0 6px;}


.scrollable-area-wrapper{
	position:relative;
	width:100%;
}
.scrollable-area-wrapper .vscrollbar{
	position:absolute;
	top:0;
	right:-2px;
	width:19px;
	height:108px;
}
.scrollable-area-wrapper .vscroll-line{
	width:19px;
	height:108px;
	float:left;
	/*background:url(../images/sprite-4.png) no-repeat 0 -192px;*/
}
.scrollable-area-wrapper .vscroll-slider{
	width:18px;
	/*background:url(../images/bg-slider.gif) repeat-y -64px 0;*/
	overflow:hidden;
}
.scrollable-area-wrapper .scroll-bar-top,
.scrollable-area-wrapper .scroll-bar-bottom{
	/*background:url(../images/bg-slider.gif) no-repeat;*/
	height:7px;
	position:absolute;
	width:18px;
	top:0;
	left:0;
}
.scrollable-area-wrapper .scroll-bar-bottom{
	bottom:0;
	top:auto;
	background-position:-32px 100%;
}
.btn-disabled{background:none !important;}
.lightbox-holder{
	overflow:hidden;
	position:relative;
	height:0;
}
.text-enlarger{
	font-size:16px;
	line-height:20px;
}

.title{
	padding:12px 0 0;
	width:573px;
	overflow:hidden;
	background-color:#fff;
	padding-top:0;
}
	.title h2{    color: #83156f!important;
    margin: 0;}
	#fancybox-wrap{ top:150px!important;}
.title-holder{
	overflow:hidden;
	padding:20px;
	padding-bottom:0;}
.text-title{
	color:#fff;
	margin:0;
}
#fancybox-wrap{ width:500px!important;}
#fancybox-content{ width:500px!important;}
#text-enlarger{ background:#fff; border:1px solid #fff; overflow: hidden;}
#fancybox-overlay{ background-color:#000!important; opacity:0.4!important;}
.text-enlarger-body{
padding:20px;
	width:100%;
	overflow:hidden;
	font-size:15px;
	padding-top:10px;

}
.content-holder{
	overflow:hidden;
	padding:0;
}
.content-holder p{margin:0 0 19px;}
.txt-area{
	display:inline-block;
	vertical-align:top;
	margin:0 0 19px;
	line-height:22px;
	color: rgba(0,0,0,.87);
}
#enlarger-size-small,
#enlarger-size-medium,
#enlarger-size-large{
	color:#000;
	font-size:13px;
	font-weight:bold;
	text-align:center;
}

#enlarger-size-medium{font-size:17px;}
#enlarger-size-large{font-size:20px;}
.enlarger-bar{
	margin:0 0 10px;
	max-width: 420px;
	text-align:center;
}

.size-link{
	display:inline-block;
	text-align:left;
	text-decoration:none;
	border:1px solid #83156f;
	border-radius: 5px;
    padding: 10px;
    width: 100%;

}
.size-link:hover{
	background:#fafafa;
}

.popup{
	/*background:url(../images/sprite-5.png) no-repeat;*/
	padding:15px 0 0;
	width:239px;
	overflow:hidden;
	position:relative;
}
.popup-holder{
	/*background:url(../images/sprite-5.png) no-repeat -261px 100%;*/
	padding:0 0 15px;
	width:239px;
	overflow:hidden;
}
.popup-frame{
	/*background:url(../images/sprite-5.png) repeat-y -521px 0;*/
	padding:2px 19px 0 20px;
	width:200px;
	text-align:center;
	overflow:hidden;
}
.open .popup-box{display:block;}
.ico-size{vertical-align:middle;}
#main .list{
	padding:0;
	margin:0;
	list-style:none;
	overflow:hidden;
	counter-reset:item;
}
#main .list > li{
	overflow:hidden;
	padding:0 0 20px;
	background:none;
    list-style-type: none;

}


/*clearing radiobuttons*/

.web-form-portlet .uni-form .block-labels label, .web-form-portlet .uni-form .block-labels .label {
	clear: both;
	line-height: 25px;
}

.web-form-portlet textarea {
	min-width: 400px;
}

/*remove clearing - adding :after*/

.web-form-portlet .uni-form .ctrl-holder {
	overflow: visible;
}
.web-form-portlet .uni-form .ctrl-holder:after, 
.info-form .row:after,
.info-form .select-holder:after,
.journal-content-article:after {
	content: ".";
	display: block;
	clear: both;
	visibility: hidden;
	line-height: 0;
	height: 0;
}

.info-textarea {
	height: 83px;
    resize: none;
    width: 732px;
}

/*dockbar styling*/
.dockbar-span {
	height: 36px;
	background: #FF7216;
	width: 100%;
	border-bottom: 1px solid #BF3F3F;
}
.dockbar-wrap {
	width: 960px;
	height: 36px;
	position: relative;
	margin: 0 auto;
}
.js .interactive-mode {
    right: 0;
    top: 4px;
}
.js .interactive-mode h2, .js .interactive-mode h2 span, .js .interactive-mode {
	background: none;
}
.js .interactive-mode h2 {
	padding: 0;
}
.js .interactive-mode h2 span {
	border: medium none;
	padding: 5px 15px;
	border: 1px solid #BF3F3F;
}

.loader {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 9999;
    /*background: url('../images/pageLoaderBlue.gif') 50% 50% no-repeat rgb(249,249,249);*/
    opacity: .8;
}`, "",{"version":3,"sources":["webpack://./src/styles/screen.css"],"names":[],"mappings":"AAAA,EAAE,iBAAiB,CAAC;;AAEpB;CACC,eAAe;CACf,eAAe;AAChB;AACA,cAAc,eAAe,CAAC;AAC9B,mBAAmB,cAAc,CAAC;;;AAGlC;CACC,iBAAiB;CACjB,UAAU;AACX;AACA;CACC,iBAAiB;CACjB,KAAK;CACL,UAAU;CACV,UAAU;CACV,YAAY;AACb;AACA;CACC,UAAU;CACV,YAAY;CACZ,UAAU;CACV,6DAA6D;AAC9D;AACA;CACC,UAAU;CACV,4DAA4D;CAC5D,eAAe;AAChB;AACA;;CAEC,qDAAqD;CACrD,UAAU;CACV,iBAAiB;CACjB,UAAU;CACV,KAAK;CACL,MAAM;AACP;AACA;CACC,QAAQ;CACR,QAAQ;CACR,8BAA8B;AAC/B;AACA,cAAc,0BAA0B,CAAC;AACzC;CACC,eAAe;CACf,iBAAiB;CACjB,QAAQ;AACT;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,qBAAqB;CACrB,aAAa;AACd;CACC,cAAc,wBAAwB;IACnC,SAAS,CAAC;CACb,gBAAgB,mBAAmB,CAAC;AACrC;CACC,eAAe;CACf,YAAY;CACZ,gBAAgB,CAAC;AAClB;CACC,UAAU;CACV,QAAQ;AACT;AACA,gBAAgB,qBAAqB,CAAC;AACtC,mBAAmB,qBAAqB,CAAC;AACzC,gBAAgB,eAAe,EAAE,qBAAqB,EAAE,gBAAgB,CAAC;AACzE,mBAAmB,+BAA+B,EAAE,qBAAqB,CAAC;AAC1E;AACA,YAAY;CACX,UAAU;CACV,eAAe;CACf,cAAc;CACd,gBAAgB;;AAEjB;AACA;CACC,eAAe;CACf,SAAS;AACV;AACA,kBAAkB,eAAe,CAAC;AAClC;CACC,oBAAoB;CACpB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,sBAAsB;AACvB;AACA;;;CAGC,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA,sBAAsB,cAAc,CAAC;AACrC,qBAAqB,cAAc,CAAC;AACpC;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,oBAAoB;CACpB,wBAAwB;CACxB,kBAAkB;IACf,aAAa;IACb,WAAW;;AAEf;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,oDAAoD;CACpD,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,gEAAgE;CAChE,gBAAgB;CAChB,WAAW;CACX,eAAe;AAChB;AACA;CACC,4DAA4D;CAC5D,uBAAuB;CACvB,WAAW;CACX,iBAAiB;CACjB,eAAe;AAChB;AACA,iBAAiB,aAAa,CAAC;AAC/B,UAAU,qBAAqB,CAAC;AAChC;CACC,SAAS;CACT,QAAQ;CACR,eAAe;CACf,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;IACZ,qBAAqB;;AAEzB;;;AAGA,wBAAwB;;AAExB;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,kCAAkC;;AAElC;CACC,iBAAiB;AAClB;AACA;;;;CAIC,YAAY;CACZ,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd,SAAS;AACV;;AAEA;CACC,YAAY;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA,kBAAkB;AAClB;CACC,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,gCAAgC;AACjC;AACA;CACC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,cAAc;AACf;AACA;IACI,QAAQ;IACR,QAAQ;AACZ;AACA;CACC,gBAAgB;AACjB;AACA;CACC,UAAU;AACX;AACA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sFAAsF;IACtF,WAAW;AACf","sourcesContent":["*{font-size:100.01%;}\r\n\r\n.holder{\r\n\toverflow:hidden;\r\n\tmargin:0 0 31px;\r\n}\r\n.items-holder{overflow:hidden;}\r\n#content .holder p{margin:0 0 6px;}\r\n\r\n\r\n.scrollable-area-wrapper{\r\n\tposition:relative;\r\n\twidth:100%;\r\n}\r\n.scrollable-area-wrapper .vscrollbar{\r\n\tposition:absolute;\r\n\ttop:0;\r\n\tright:-2px;\r\n\twidth:19px;\r\n\theight:108px;\r\n}\r\n.scrollable-area-wrapper .vscroll-line{\r\n\twidth:19px;\r\n\theight:108px;\r\n\tfloat:left;\r\n\t/*background:url(../images/sprite-4.png) no-repeat 0 -192px;*/\r\n}\r\n.scrollable-area-wrapper .vscroll-slider{\r\n\twidth:18px;\r\n\t/*background:url(../images/bg-slider.gif) repeat-y -64px 0;*/\r\n\toverflow:hidden;\r\n}\r\n.scrollable-area-wrapper .scroll-bar-top,\r\n.scrollable-area-wrapper .scroll-bar-bottom{\r\n\t/*background:url(../images/bg-slider.gif) no-repeat;*/\r\n\theight:7px;\r\n\tposition:absolute;\r\n\twidth:18px;\r\n\ttop:0;\r\n\tleft:0;\r\n}\r\n.scrollable-area-wrapper .scroll-bar-bottom{\r\n\tbottom:0;\r\n\ttop:auto;\r\n\tbackground-position:-32px 100%;\r\n}\r\n.btn-disabled{background:none !important;}\r\n.lightbox-holder{\r\n\toverflow:hidden;\r\n\tposition:relative;\r\n\theight:0;\r\n}\r\n.text-enlarger{\r\n\tfont-size:16px;\r\n\tline-height:20px;\r\n}\r\n\r\n.title{\r\n\tpadding:12px 0 0;\r\n\twidth:573px;\r\n\toverflow:hidden;\r\n\tbackground-color:#fff;\r\n\tpadding-top:0;\r\n}\r\n\t.title h2{    color: #83156f!important;\r\n    margin: 0;}\r\n\t#fancybox-wrap{ top:150px!important;}\r\n.title-holder{\r\n\toverflow:hidden;\r\n\tpadding:20px;\r\n\tpadding-bottom:0;}\r\n.text-title{\r\n\tcolor:#fff;\r\n\tmargin:0;\r\n}\r\n#fancybox-wrap{ width:500px!important;}\r\n#fancybox-content{ width:500px!important;}\r\n#text-enlarger{ background:#fff; border:1px solid #fff; overflow: hidden;}\r\n#fancybox-overlay{ background-color:#000!important; opacity:0.4!important;}\r\n.text-enlarger-body{\r\npadding:20px;\r\n\twidth:100%;\r\n\toverflow:hidden;\r\n\tfont-size:15px;\r\n\tpadding-top:10px;\r\n\r\n}\r\n.content-holder{\r\n\toverflow:hidden;\r\n\tpadding:0;\r\n}\r\n.content-holder p{margin:0 0 19px;}\r\n.txt-area{\r\n\tdisplay:inline-block;\r\n\tvertical-align:top;\r\n\tmargin:0 0 19px;\r\n\tline-height:22px;\r\n\tcolor: rgba(0,0,0,.87);\r\n}\r\n#enlarger-size-small,\r\n#enlarger-size-medium,\r\n#enlarger-size-large{\r\n\tcolor:#000;\r\n\tfont-size:13px;\r\n\tfont-weight:bold;\r\n\ttext-align:center;\r\n}\r\n\r\n#enlarger-size-medium{font-size:17px;}\r\n#enlarger-size-large{font-size:20px;}\r\n.enlarger-bar{\r\n\tmargin:0 0 10px;\r\n\tmax-width: 420px;\r\n\ttext-align:center;\r\n}\r\n\r\n.size-link{\r\n\tdisplay:inline-block;\r\n\ttext-align:left;\r\n\ttext-decoration:none;\r\n\tborder:1px solid #83156f;\r\n\tborder-radius: 5px;\r\n    padding: 10px;\r\n    width: 100%;\r\n\r\n}\r\n.size-link:hover{\r\n\tbackground:#fafafa;\r\n}\r\n\r\n.popup{\r\n\t/*background:url(../images/sprite-5.png) no-repeat;*/\r\n\tpadding:15px 0 0;\r\n\twidth:239px;\r\n\toverflow:hidden;\r\n\tposition:relative;\r\n}\r\n.popup-holder{\r\n\t/*background:url(../images/sprite-5.png) no-repeat -261px 100%;*/\r\n\tpadding:0 0 15px;\r\n\twidth:239px;\r\n\toverflow:hidden;\r\n}\r\n.popup-frame{\r\n\t/*background:url(../images/sprite-5.png) repeat-y -521px 0;*/\r\n\tpadding:2px 19px 0 20px;\r\n\twidth:200px;\r\n\ttext-align:center;\r\n\toverflow:hidden;\r\n}\r\n.open .popup-box{display:block;}\r\n.ico-size{vertical-align:middle;}\r\n#main .list{\r\n\tpadding:0;\r\n\tmargin:0;\r\n\tlist-style:none;\r\n\toverflow:hidden;\r\n\tcounter-reset:item;\r\n}\r\n#main .list > li{\r\n\toverflow:hidden;\r\n\tpadding:0 0 20px;\r\n\tbackground:none;\r\n    list-style-type: none;\r\n\r\n}\r\n\r\n\r\n/*clearing radiobuttons*/\r\n\r\n.web-form-portlet .uni-form .block-labels label, .web-form-portlet .uni-form .block-labels .label {\r\n\tclear: both;\r\n\tline-height: 25px;\r\n}\r\n\r\n.web-form-portlet textarea {\r\n\tmin-width: 400px;\r\n}\r\n\r\n/*remove clearing - adding :after*/\r\n\r\n.web-form-portlet .uni-form .ctrl-holder {\r\n\toverflow: visible;\r\n}\r\n.web-form-portlet .uni-form .ctrl-holder:after, \r\n.info-form .row:after,\r\n.info-form .select-holder:after,\r\n.journal-content-article:after {\r\n\tcontent: \".\";\r\n\tdisplay: block;\r\n\tclear: both;\r\n\tvisibility: hidden;\r\n\tline-height: 0;\r\n\theight: 0;\r\n}\r\n\r\n.info-textarea {\r\n\theight: 83px;\r\n    resize: none;\r\n    width: 732px;\r\n}\r\n\r\n/*dockbar styling*/\r\n.dockbar-span {\r\n\theight: 36px;\r\n\tbackground: #FF7216;\r\n\twidth: 100%;\r\n\tborder-bottom: 1px solid #BF3F3F;\r\n}\r\n.dockbar-wrap {\r\n\twidth: 960px;\r\n\theight: 36px;\r\n\tposition: relative;\r\n\tmargin: 0 auto;\r\n}\r\n.js .interactive-mode {\r\n    right: 0;\r\n    top: 4px;\r\n}\r\n.js .interactive-mode h2, .js .interactive-mode h2 span, .js .interactive-mode {\r\n\tbackground: none;\r\n}\r\n.js .interactive-mode h2 {\r\n\tpadding: 0;\r\n}\r\n.js .interactive-mode h2 span {\r\n\tborder: medium none;\r\n\tpadding: 5px 15px;\r\n\tborder: 1px solid #BF3F3F;\r\n}\r\n\r\n.loader {\r\n    position: fixed;\r\n    left: 0px;\r\n    top: 0px;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9999;\r\n    /*background: url('../images/pageLoaderBlue.gif') 50% 50% no-repeat rgb(249,249,249);*/\r\n    opacity: .8;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
